import Ahoy from './ahoy'
import Criteo from './criteo'
import GTag from './gtag'
import MetaPixel from './meta-pixel'
import Bugsnag from './bugsnag'
import Clarity from './clarity'
import Intercom from './intercom'
import LoggingMixin from 'lib/logging-mixin'
import { productionEnv } from 'lib/env'

// the event type is unified for all conversions, and looks like this:
// { event, [type], [...otherData] }
class ConversionSet extends LoggingMixin() {
  constructor (conversionSet) {
    super()
    this.conversionSet = conversionSet
  }

  register (conversion) {
    this.conversionSet.push(conversion)
  }

  async push (...args) {
    return this.conversionSet.forEach((conversion) => {
      try {
        return conversion.push(...args)
      } catch (e) {
        this.error('push', e)
      }
    })
  }

  static get instance () {
    if (this._instance) return this._instance
    this._instance = new this(this.default_conversions)

    return this._instance
  }

  static get default_conversions () {
    if (productionEnv) {
      return [Bugsnag, Ahoy, GTag, Intercom, Criteo, MetaPixel, Clarity].map(klass => klass.instance())
    } else {
      return [Ahoy.instance()]
    }
  }
}

export default ConversionSet.instance
